module.exports = __webpack_public_path__ + "img/messenger.7c8b6172.svg";